import { createEnvelopeSource } from './create-envelope-source';

/**
 * Coupons-redeemed source over the standardized envelope
 * (`GET /analytics/coupons/redeemed`), scoped to the promotions in no campaign.
 *
 * `couponsRedeemedRpp` is disjoint from this count rather than a subset of it,
 * and `coupon-activation`'s `claimed` carries the same scope on a different
 * subject: never sum this with either.
 *
 * The endpoint also serves `reissued`, plus `available` / `redemptionRate` for
 * a single promotion carrying a catalog cap; none is declared until a card
 * reads it. Total-only (`capabilities.daily=false`), so no `line` form.
 */
export const couponRedeemedSource = createEnvelopeSource({
    label: 'Coupons redeemed',
    endpoint: 'analytics/coupons/redeemed',
    metrics: [
        { id: 'couponsRedeemed', label: 'Coupons redeemed', type: 'scalar' },
    ],
    forms: ['number', 'pie'],
    regionGrain: 'province',
});
